// TPage.jsx
import React, { useState, useEffect } from "react";
import { getRecommendedMatches } from "../features/participant/match/lobby/Api/GenericApi";
import "bootstrap/dist/css/bootstrap.min.css";

function TPage() {
  const [match, setMatch] = useState(null);
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");

  useEffect(() => {
    async function fetchMatch() {
      try {
        const response = await getRecommendedMatches();
        if (response && response.length > 0) {
          const firstMatch = response[0];
          setMatch(firstMatch);

          // Show toast message inside the card
          setToastMessage(`Match Found! Go to Active Matches: ${firstMatch.match_info.player}`);
          setShowToast(true);

          // Hide toast after 3 seconds
          setTimeout(() => setShowToast(false), 3000);
        }
      } catch (error) {
        console.error("Failed to fetch matches:", error);
      }
    }

    fetchMatch();
  }, []);

  if (!match) {
    return <div className="text-center mt-5 fs-3">Loading match...</div>;
  }

  const { game_type, sport_name, player } = match.match_info;

  const handleBack = () => {
    window.history.back(); // simple back navigation
  };

  return (
    <div className="d-flex justify-content-center align-items-center vh-100 bg-light">
      {/* Card container */}
      <div
        className="d-flex flex-column justify-content-center align-items-center p-4 border rounded shadow-sm position-relative"
        style={{ width: "600px", minHeight: "350px", backgroundColor: "#fff" }}
      >
        {/* Toast inside card */}
        {showToast && (
          <div
            className="position-absolute top-0 start-50 translate-middle-x p-2 rounded shadow"
            style={{ backgroundColor: "#0d6efd", color: "#fff", zIndex: 10 }}
          >
            {toastMessage}
          </div>
        )}

        {/* Game Type & Sport Name */}
        <div className="d-flex justify-content-center align-items-center mb-4">
          <span className="fs-2 fw-bold me-3">{game_type.toUpperCase()}</span>
          <span className="fs-5 text-primary fw-bold">{sport_name}</span>
          <span className="fs-5 text-muted ms-3">{player}</span>
        </div>

        {/* Teams */}
        <div className="d-flex justify-content-around align-items-start w-100">
          <TeamColumn team={match.team_1} title="Team 1" />
          <div className="fw-bold fs-3 mx-3 align-self-center">VS</div>
          <TeamColumn team={match.team_2} title="Team 2" />
        </div>

        {/* Back Button */}
        <div className="mt-4 d-flex justify-content-center w-100">
          <button className="btn btn-secondary" onClick={handleBack}>
            Back
          </button>
        </div>
      </div>
    </div>
  );
}

const TeamColumn = ({ team, title }) => (
  <div className="d-flex flex-column align-items-center">
    <span className="fw-bold mb-2">{title}</span>
    {team.map((p) => (
      <div key={p.id} className="d-flex align-items-center mb-2">
        <img
          src={p.profile_image}
          alt={p.full_name}
          className="rounded-circle me-2"
          style={{ width: "45px", height: "45px", objectFit: "cover" }}
        />
        <span className="fs-6 fw-bold">{p.full_name}</span>
      </div>
    ))}
  </div>
);

export default TPage;
